import script from "./PasswordResetComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetComponent.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetComponent.vue?vue&type=style&index=0&id=5aa88785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa88785"]])

export default __exports__